angular.module('NiacsProjectApp.services-jsonapi', [])
.provider('$jsonApiResource',[function() {
  // cached $update/$save references (terms/nodes)
  var REF_CACHE = {};
  function JsonApiUtils(data,included) {
    this.data = data;
    this.included = included;
  }
  JsonApiUtils.prototype.includedById = function(id) {
    return (this.included||[]).find(function(o) { return o.id === id; });
  };
  JsonApiUtils.prototype.related = function(field) {
    var data = this.data;
    var relationshipData = data.relationships && data.relationships[field] && data.relationships[field].data;
    if(relationshipData) {
      if(Array.isArray(relationshipData)) {
        if(relationshipData.length) {
          var self = this;
          return relationshipData.map(function(d) {
            return self.includedById(d.id);
          });
        }
      } else {
        var uuid = relationshipData.id;
        return !!uuid ? this.includedById(uuid) : undefined;
      }
    }
    return null;
  };
  JsonApiUtils.prototype.relatedId = function(field) {
    var data = this.data;
    var relationshipData = data.relationships && data.relationships[field] && data.relationships[field].data;
    if(relationshipData) {
      if(Array.isArray(relationshipData)) {
          return relationshipData.map(function(o) {
            return o.id;
          });
      } else {
        return relationshipData.id;
      }
    }
    return null;
  };
  JsonApiUtils.prototype.relatedAttribute = function(field,att) {
    var related = this.related(field);
    if(related) {
      if(Array.isArray(related)) {
        if(related.length) {
          return related.map(function(r) {
            return r && r.attributes && r.attributes[att];
          });
        }
      } else {
        return related.attributes && related.attributes[att];
      }
    }
    return null;
  };
  function make_link(o) {
    return {
      title: o.title,
      url: o.uri            
    };
  }
  function cast_link(l) {
    if(l) {
      if(Array.isArray(l)) {
        if(l.length) {
          return l.map(make_link);
        }
      } else {
        return make_link(l);
      }
    }
    return null;
  }
  JsonApiUtils.prototype.link = function(attribute) {
    return cast_link(this.data.attributes[attribute]);
  };
  function make_file(o) {
    var atts = o.attributes;
    return {
      id: atts.drupal_internal__fid,
      // TODO description?
      filemime: atts.filemime,
      filename: atts.filename,
      filesize: atts.filesize,
      // NOTE: this is not fully qualified but should be OK since the app is not running
      // under some sub-path of another site.
      self: atts.uri.url
    };
  }
  function cast_file(related) {
    if(related) {
      if(Array.isArray(related)) {
        if(related.length) {
          return related.map(make_file);
        }
      } else {
        return make_file(related);
      }
    }
    return null;
  }
  JsonApiUtils.prototype.file = function(field) {
    return cast_file(this.related(field));
  };
  JsonApiUtils.prototype.relatedResource = function(field,ResourceClass) {
    var self = this;
    function make_resource(o) {
      var ro = new ResourceClass();
      ro.$jsonApi = new JsonApiUtils(o,self.included);
      ro.$populateFromJsonApiResponse();
      return ro;
    }
    var related = this.related(field);
    if(related) {
      if(Array.isArray(related)) {
        if(related.length) {
          return related.map(make_resource);
        }
      } else {
        return make_resource(related);
      }
    }
    return null;
  };
  JsonApiUtils.prototype.attributeValue = function(propertyDefinition) {
    var v = this.data.attributes[propertyDefinition.attribute];
    if(v && propertyDefinition.nested) {
      v = v[propertyDefinition.nested];
    }
    // v will fail for "0"
    if((v || v === "0" || v === 0) && propertyDefinition.type) {
      switch(propertyDefinition.type) {
        case 'timestamp':
          v = (new Date(v)).getTime();
          break;
        case 'date':
          var parts = v.split('-');
          var year = parseInt(parts[0]);
          var monthIndex = parseInt(parts[1])-1;
          var day = parseInt(parts[2]);
          v = new Date(year,monthIndex,day);
          break;
        case 'boolean':
          v = !!v;
          break;
        case 'number':
          v = Number(v);
          break;
        case 'link':
          v = cast_link(v);
          break;
        case 'json':
          v = JSON.parse(v);
          break;
        default:
          throw new Error('invalid property definition (attribute) type '+propertyDefinition.type,propertyDefinition);
      }
    }
    return v||null;
  };
  JsonApiUtils.prototype.serializeAttributeValue = function(value,propertyDefinition) {
    if(propertyDefinition.type) {
      // this functionality is sparse only based on what the application actually currently uses....
      switch(propertyDefinition.type) {
        case 'number':
          var to = typeof(value);
          return to === 'number' ? value : to === 'string' ? Number(value) : value;
        case 'date':
          throw new Error('TODO serialize date',value);
        case 'json':
          return angular.toJson(value);
        default:
          throw new Error('invalid property definition (attribute) type '+propertyDefinition.type,propertyDefinition);
      }
    }
    return value;
  };
  JsonApiUtils.prototype.relationshipValue = function(propertyDefinition) {
    var type = propertyDefinition.type;
    var field = propertyDefinition.relationship;
    if (typeof(type) === 'function') {
      return this.relatedResource(field,type);
    } else if (type === 'file') {
      return this.file(field);
    } else if (propertyDefinition.nested) {
      return this.relatedAttribute(field,propertyDefinition.nested);
    }
    throw new Error('invalid property definition (relationship) type '+propertyDefinition.type,propertyDefinition);
  };
  // see https://docs.angularjs.org/api/ngResource/service/$resource
  this.$get = ['$http','$q',function($http,$q){
    var getCsrfToken = (function() {
      var token;
      return function() {
        var def = $q.defer();
        if(token) {
          def.resolve(token);
        } else {
          $http.get('/session/token').then(function(response) { def.resolve(token = response.data); });
        }
        return def.promise;
      };
    })();
    return function(type,bundle,definition) {
      var id_attr;
      if(type === 'node') {
        id_attr = 'drupal_internal__nid';
      } else if (type === 'taxonomy_term') {
        id_attr = 'drupal_internal__tid';
      } else if (type === 'user') {
        id_attr = 'drupal_internal__uid';
      } else {
        // for now just node
        throw new Error ('unsupported type '+type);
      }
      function Resource(data) {
        if(data && typeof(data) === 'object') {
          Object.assign(this,data);
        }
      }
      Resource.$type = type;
      Resource.$bundle = bundle;
      Resource.$getCsrfToken = getCsrfToken;
      // sub-classes must over-ride to build all the JsonApi input necessary to pull
      // in everything a type involves, these go along with query/get requests
      Resource.prototype.$includeParams = {};
      // resources that are nested within other resources need to supply this with the
      // base attributes they use in $populateFromJsonApiResponse so that what gets pulled
      // into the response is sufficient
      Resource.prototype.$nestedIncludes = undefined;
      Resource.$mergeIncludeParams = function(field,ResourceClass) {
        function add_to_base_includes(includes) {
          if(includes) {
            includes.split(',').forEach(function(i) {
              Resource.prototype.$includeParams.include += ','+field+'.'+i;
            });
          }
        }
        for(var key in ResourceClass.prototype.$includeParams) {
          if(key === 'include') {
            add_to_base_includes(ResourceClass.prototype.$includeParams.include);
            var includes = ResourceClass.prototype.$nestedIncludes; // these are base properties, not references
            includes = !!includes ? includes+','+ResourceClass.prototype.$includeParams.include : ResourceClass.prototype.$includeParams.include;
            Resource.prototype.$includeParams['fields['+ResourceClass.$type+'--'+ResourceClass.$bundle+']'] = includes;
          } else if(Resource.prototype.$includeParams[key]) {
            if(Resource.prototype.$includeParams[key] !== ResourceClass.prototype.$includeParams[key]) {
              // need to merge the two
              console.warn('TODO merge',Resource.prototype.$includeParams[key],ResourceClass.prototype.$includeParams[key]);
            }
          } else {
            // just add
            Resource.prototype.$includeParams[key] = ResourceClass.prototype.$includeParams[key];
          }
        }
      };
      // sub-classes should use the $jsonApi object's data and include
      // properties to populate themselves. using properties rather than
      // parameters so they can move between objects via Object.assign
      // and there's always a reference within the object itself as to
      // its JSON API origins
      Resource.prototype.$populateFromJsonApiResponse = function() {};

      // if provided a definition then generate $includeParams, $nestedIncludes and $populateFromJsonApiResponse
      if(definition) {
        var properties = Object.keys(definition);
        var propertyDefinitions = properties.map(function(prop) { return definition[prop]; });
        var attributes = propertyDefinitions.filter(function(pdef) { return !!pdef.attribute; });
        var relationships = propertyDefinitions.filter(function(pdef) { return !!pdef.relationship; });
        Resource.prototype.$nestedIncludes = attributes.map(function(pdef) { return pdef.attribute; }).join(',');
        Resource.prototype.$includeParams.include = relationships.map(function(pdef) { return pdef.relationship; })
          .reduce(function(set,rel) {
            if(set.indexOf(rel) === -1) {
              set.push(rel);
            }
            return set;
          }, [])
          .join(',');
        // add fields input for any basic drupal relationships
        relationships.forEach(function(rel) {
            var type = typeof(rel.type) === 'string' && rel.type;
            var bundle = rel.bundle;
            if(type && bundle && rel.nested) { // if not specifying nested then just pull in all details
              var key = 'fields['+type+'--'+bundle+']';
              if(Resource.prototype.$includeParams[key]) {
                Resource.prototype.$includeParams[key] += ','+rel.nested;
              } else {
                Resource.prototype.$includeParams[key] = rel.nested;
              }
            } else if (type === 'file') {
              // no-op, let entire file contents come down.
            }
          });
        // deal with any nested resources
        relationships.filter(function(rel) {
            return typeof(rel.type) === 'function';
          }).forEach(function(rel) {
            Resource.$mergeIncludeParams(rel.relationship,rel.type);
          });
        Resource.prototype.$populateFromJsonApiResponse = function() {
          var self = this;
          var _o = {};
          properties.forEach(function(prop) {
            var propertyDefinition = definition[prop];
            if(propertyDefinition.attribute) {
              _o[prop] = self.$jsonApi.attributeValue(propertyDefinition);
            } else if (propertyDefinition.relationship) {
              _o[prop] = self.$jsonApi.relationshipValue(propertyDefinition);
            } else {
              throw new Error(Resource.$type+'--'+Resource.$bundle+ ' - bad property definition',propertyDefinition);
            }
          });
          Object.assign(this,_o);
          //console.debug(Resource.$type+'--'+Resource.$bundle,this);
        };
        var SER_ATT_IGNORES = ['drupal_internal__nid','created','changed'];
        var CHASE_REF = function(propertyDefinition,id) {
          var def = $q.defer();
          REF_CACHE[propertyDefinition.type] = REF_CACHE[propertyDefinition.type]||{};
          var refs = REF_CACHE[propertyDefinition.type];
          if(refs[id]) {
            def.resolve({
              uuid: refs[id],
              def: propertyDefinition
            });
          } else {
            var params = {};
            params['filter['+propertyDefinition.nested+'][value]'] = id;
            params['fields['+propertyDefinition.type+'--'+propertyDefinition.bundle+']'] = propertyDefinition.nested;
            $http.get('/jsonapi/'+propertyDefinition.type+'/'+propertyDefinition.bundle,{params:params})
              .then(function(response) {
                var data = response.data.data;
                if(data.length !== 1) {
                  return def.reject('Unexpected response for '+propertyDefinition.type+'--'+propertyDefinition.bundle+' with id '+id+ ' expected a single result but received '+data.length);
                }
                var uuid = data[0].id;
                if(!uuid) {
                  return def.reject('Unexpected response for '+propertyDefinition.type+'--'+propertyDefinition.bundle+' with id '+id+' missing '+ propertyDefinition.nested);
                }
                refs[id] = uuid;
                def.resolve({
                  uuid: uuid,
                  def: propertyDefinition
                });
              });
          }
          return def.promise;
        };
        /**
         * @returns {string} The uuid of the server side resource.
         */
        Resource.prototype.$uuid = function() {
            return this.$jsonApi && this.$jsonApi.data ? this.$jsonApi.data.id : null;
        };
        /**
         * @returns {Promise} ($q) with a copy of the JSON api data to send with $save or $update
         */
        Resource.prototype.$serialize = function() {
          var def = $q.defer();
          var self = this;
          // create an empty data object to put content in to send to the server
          var data = {
            type: Resource.$type+'--'+Resource.$bundle,
            attributes: {},
            relationships: {}
          };
          if(!self.$jsonApi) { // $save
            self.$jsonApi = new JsonApiUtils({},[]);
          }
          if(self.$jsonApi.data.id) {
            data.id = self.$jsonApi.data.id;
          }
          //JSON.parse(JSON.stringify(this.$jsonApi.data));
          var ref_promises = [];
          properties.forEach(function(prop) {
            var propertyDefinition = definition[prop];
            var a,n,v;
            if(propertyDefinition.attribute) {
              a = propertyDefinition.attribute;
              if(SER_ATT_IGNORES.indexOf(a) !== -1) {
                return; // skip can't update
              }
              n = propertyDefinition.nested;
              v = self.$jsonApi.serializeAttributeValue(self[prop],propertyDefinition);
              if(n) {
                data.attributes[a] = a === 'body' ? {} : data.attributes[a]||{};
                data.attributes[a][n] = v;
              } else {
                data.attributes[a] = v;
              }
            } else if (propertyDefinition.relationship) {
              n = propertyDefinition.nested;
              if(n !== 'drupal_internal__tid' && n !== 'drupal_internal__nid') {
                return; // only chase nid/tid, this is a nested inclusion of some info from the reference
              }
              v = self[prop];
              if(!v) {
                // null reference, nothing to chase, force to null
                data.relationships[propertyDefinition.relationship] = {data:null};
              } else {
                ref_promises.push(CHASE_REF(propertyDefinition,v));
              }
            } else {
              throw new Error(Resource.$type+'--'+Resource.$bundle+ ' - bad property definition',prop);
            }
          });
          // once all tax/node references have been stitched back in then resolve
          $q.all(ref_promises).then(function(reference_results) {
            // stitch reference results into the data
            reference_results.forEach(function(ref) {
              var id = ref.uuid;
              var propertyDefinition = ref.def;
              data.relationships[propertyDefinition.relationship] = {
                data: {
                  id: id,
                  type: propertyDefinition.type+'--'+propertyDefinition.bundle
                }
              };
            });
            def.resolve(data);
          });
          return def.promise;
        };

        Resource.prototype.$action = function(method,data) {
          var self = this;
          return Resource.$getCsrfToken().then(function(token) {
            var write_url = '/jsonapi/'+Resource.$type+'/'+Resource.$bundle;
            if(method === 'patch') {
              write_url += '/'+self.$jsonApi.data.id;
            }
            return $http[method](
              write_url,
              {data:data},
              {
                params: Resource.prototype.$includeParams,
                headers: {
                  'X-CSRF-Token': token
                }
              })
              .then(function(response) {
                // stitch the results back into this object
                self.$jsonApi = new JsonApiUtils(response.data.data,response.data.included);
                self.$populateFromJsonApiResponse();
                return self;
              });
          });
        };

        Resource.prototype.$write = function(method,input,callback) {
          if(typeof('input') !== 'function') {
            console.log('TODO remove input from $update call');
          } else {
            callback = input;
          }
          console.log('$write',this);
          var self = this;
          return self.$serialize().then(function(data) {
            return self.$action(method,data).then(function(o)  {
              if(callback) {
                callback(o);
              }
              return o;
            });
          });
        };

        Resource.prototype.$update = function(input,callback) {
          return this.$write('patch',input,callback);
        };

        Resource.prototype.$save = function(input,callback) {
          return this.$write('post',input,callback);
        };

        Resource.prototype.$delete = function(callback) {
          var self = this;
          return Resource.$getCsrfToken().then(function(token) {
            return $http.delete(
              '/jsonapi/'+Resource.$type+'/'+Resource.$bundle+'/'+self.$jsonApi.data.id,
              {
                headers: {
                  'X-CSRF-Token': token
                }
              })
              .then(function(response) {
                if(callback) {
                  callback(response);
                }
                return self;
              });
          });
        };
      }
    
      // NOTE: overridePrefix helps out with a workaround to a JSON API permissions issue for LMS instructors
      // see app_src/js/lms/services/CourseProject's use of NiacsProject.query
      // and src/Controller/LmsResource::courseProjects
      Resource.query = function(p1,p2,overridePrefix) {
        var params,callback;
        if(typeof(p1) === 'function') {
          callback = p1;
        } else {
          params = p1;
          callback = p2;
        }
        var _params = {};
        Object.assign(_params,Resource.prototype.$includeParams);
        // handle user input params second so they can over-ride includes in very
        // special cases (e.g. project reporting)
        if(params) {
          Object.assign(_params,params);
        }
        var r = {};
        r.$resolved = false;
        r.$promise = $http.get((overridePrefix||'/jsonapi')+'/'+type+'/'+bundle,{params:_params})
          .then(function(response) {
            r.$resolved = true;
            // coerce a JSON API response into what the legacy API would return so the underlying
            // code can all remain consistent
            var data = response.data;
            // this is different than ngResource in that the contents of .list are already coerced into resources
            r.list = data.data.map(function(o) {
              var ro = new Resource();
              ro.$jsonApi = new JsonApiUtils(o,data.included);
              try {
                ro.$populateFromJsonApiResponse();
              } catch (err) {
                // this shouldn't happen but can if a spammer creates a bogus project with a non JSON body
                // this avoids the app crashing here, should only show up during project reporting and allows
                // the reporting utility to flag these problem projects.
                ro.$populateError = err;
              }
              return ro;
            });
            if(callback) {
              callback(r);
            }
            return r;
          });
        // these would expose the underlying JSON API data
        // remove just to keep outside code from accessing
        // that un-coerced...
        r.$promise.success = r.$promise.failure = undefined;
        return r;
      };
      /**
       * input in all its app uses only supplies a key called `id`
       */
      Resource.get = function(input,callback) {
          var r = new Resource();
          var params = {};
          params['filter['+id_attr+'][value]'] = input.id;
          Object.assign(params,Resource.prototype.$includeParams);
          var query = Resource.query(params);
          r.$resolved = false;
          r.$promise = query.$promise
            .then(function(listResponse) {
              r.$resolved = true;
              if(listResponse.list.length) {
                Object.assign(r,listResponse.list[0]);
              }
              if(callback) {
                callback(r);
              }
              return r;
            });
          return r;
      };
      return Resource;
    };
  }];
}]);